import React from "react";
import { Card, Tabs } from "antd";
import ListAllLetters from "../../../components/Manage/Letters/ListAllLetters";
import LetterHeader from "../../../components/Manage/Letters/LetterHeader";
import DigitalSign from "../../../components/Manage/Letters/DigitalSign";
import TandC from "../../../components/Manage/Letters/T&C/TandC";
import CompanyLocation from "../../../components/Manage/Letters/Footer/CompanyLocation";
import ManageTC from "../../../components/Manage/Letters/T&C/ManageTC";

const items = [
  {
    key: "1",
    label: "Letter Header",
    children: <LetterHeader />,
  },
  {
    key: "2",
    label: "Digital Signature",
    children: <DigitalSign />,
  },
  {
    key: "3",
    label: "Company Locations",
    children: <CompanyLocation />,
  },
  {
    key: "4",
    label: "Terms & Conditions",
    children: <ManageTC />,
  },
];

const ManageLetters = () => {
  return (
    <Card size="large" title="Manage Letters">
      <Tabs
        tabPosition="left"
        size="large"
        defaultActiveKey="1"
        items={items}
      />
    </Card>
  );
};

export default ManageLetters;
